module.exports = __webpack_public_path__ + "img/leaf3.2c91d484.png";